export enum BankAccountStatus {
  Approved = "Approved",
  Pending = "Pending",
  Rejected = "Rejected",
}
